import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUser } from "react-icons/ai";
import { HiOutlineHome, HiOutlineShoppingCart } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import routes from "../../Helpers/Routes.json";
import { Context } from "../../Shared/Context/GlobalContext";
import { StyledFooter, StyledDesktopFooter } from "./style.css";

export const Footer = () => {
  const { t } = useTranslation();
  const { user, cartProducts, domain } = useContext(Context);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  const shop = domain?.shop || {};
  const shopName = shop.name || "The White Cookie";
  const shopSubtitle = shop.subtitle || "";

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalQty = cartProducts.reduce((carry, { product }) => carry + (product.quantity || 1), 0);

  if (isDesktop) {
    return (
      <StyledDesktopFooter>
        <div className="d-flex justify-content-between align-items-start px-4 py-3">
          <div>
            <h6 className="fw-bold mb-2">{shopName}</h6>
            <p className="small text-muted mb-1">{shopSubtitle}</p>
            <p className="small text-muted mb-0">
              &copy; {new Date().getFullYear()} {t("Todos los derechos reservados")}
            </p>
          </div>
          <div className="d-flex gap-3">
            <NavLink
              to={routes.Homepage.index}
              className="text-muted small text-decoration-none"
            >
              {t("Inicio")}
            </NavLink>
            <NavLink
              to={routes.OrderPage.index}
              className="text-muted small text-decoration-none d-flex align-items-center gap-1"
            >
              {t("Carrito")}
              {totalQty > 0 && (
                <span className="badge bg-dark rounded-pill">
                  {totalQty}
                </span>
              )}
            </NavLink>
            <NavLink
              to={user ? routes.AccountPage.index : routes.LoginPage.index}
              className="text-muted small text-decoration-none"
            >
              {user ? t("Mi cuenta") : t("Iniciar sesión")}
            </NavLink>
          </div>
        </div>
      </StyledDesktopFooter>
    );
  }

  return (
    <StyledFooter className="fixed-bottom d-flex justify-content-around align-items-center">
      <NavLink
        to={user ? routes.AccountPage.index : routes.LoginPage.index}
        className="d-flex flex-column align-items-center text-decoration-none p-2"
      >
        <AiOutlineUser size={20} />
        <span className="small mt-1">{t("Cuenta")}</span>
      </NavLink>

      <NavLink
        to={routes.Homepage.index}
        className="d-flex flex-column align-items-center text-decoration-none p-2"
      >
        <HiOutlineHome size={22} />
        <span className="small mt-1">{t("Inicio")}</span>
      </NavLink>

      <NavLink
        to={routes.OrderPage.index}
        className="d-flex flex-column align-items-center text-decoration-none p-2 position-relative"
      >
        <HiOutlineShoppingCart size={18} />
        <span className="small mt-1">{t("Carrito")}</span>
        {totalQty > 0 && (
          <span
            className="position-absolute badge bg-dark rounded-pill"
            style={{ top: "2px", right: "-8px", fontSize: "0.65rem" }}
          >
            {totalQty}
          </span>
        )}
      </NavLink>
    </StyledFooter>
  );
};
